import React from 'react';
import PropTypes from 'prop-types';

/**
 * Recommendations sidebar module - shows card recommendations based on deck
 */
function Recommendations({
  isCollapsed,
  onToggle,
  recommendations,
  loading,
  onAddCard,
  getProxyImageUrl,
  deckHasCards,
}) {
  return (
    <div className="sidebar-section recommendations-section">
      <div className="section-header">
        <h4>💡 Recommended Cards</h4>
        <button 
          className="collapse-btn" 
          onClick={onToggle}
          title={isCollapsed ? "Expand" : "Collapse"}
        >
          {isCollapsed ? '▶' : '▼'}
        </button>
      </div>

      {!isCollapsed && (
        <>
          {loading && (
            <div className="loading-indicator">
              <div className="spinner"></div>
              <span>Loading recommendations...</span>
            </div>
          )}
          {!loading && recommendations.length === 0 && deckHasCards && (
            <div className="no-recommendations">
              No recommendations found for your deck
            </div>
          )}
          {!loading && recommendations.length > 0 && (
            <div className="recommendations-list">
              {recommendations.map((card, index) => (
                <div 
                  key={index} 
                  className={`recommendation-item${card.feature === 'scene' ? ' scene-card' : ''}`} 
                  onClick={() => onAddCard(card)}
                >
                  <img
                    src={getProxyImageUrl(card.images?.blob?.thumbnail || card.images?.original?.thumbnail)}
                    alt={card.name}
                    className="result-thumbnail"
                    loading="lazy"
                  />
                  <div className="result-info">
                    <strong>{card.name}</strong>
                    <p className="result-number">{card.number}</p>
                    <p className="result-meta">
                      {card.characterName && <span className="character-tag">{card.characterName}</span>}
                      {card.rarity?.description && <span className="rarity-tag">{card.rarity.description}</span>}
                    </p>
                    <p className="score-display">Score: {card.recommendationScore?.toFixed(1)}</p>
                  </div>
                  <div className="recommendation-overlay">
                    <div className="overlay-content">
                      <h4>{card.name}</h4>
                      <p className="result-number">{card.number}</p>
                      <p className="result-meta">
                        {card.characterName && <span className="character-tag">{card.characterName}</span>}
                        {card.rarity?.description && <span className="rarity-tag">{card.rarity.description}</span>}
                      </p>
                      <p className="score-display">Score: {card.recommendationScore?.toFixed(1)}</p>
                      <button onClick={() => onAddCard(card)} className="add-btn-overlay">
                        Add to Deck
                      </button>
                    </div>
                  </div>
                  <button onClick={() => onAddCard(card)} className="add-btn">
                    Add
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

Recommendations.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  recommendations: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onAddCard: PropTypes.func.isRequired,
  getProxyImageUrl: PropTypes.func.isRequired,
  deckHasCards: PropTypes.bool.isRequired,
};

export default Recommendations;
